import { combineReducers } from 'redux';
import productivity from './productivity';

import { reducers as growerReducers } from '../dux/grower-dux';
import { reducers as fieldReducers } from '../dux/fields-dux';
import { reducers as fbmReducers } from '../dux/field-boundary-management-dux';
import { reducers as featureFlagReducers } from '../dux/feature-flags-dux';
import { reducers as permissionReducers } from '../dux/permissions-dux';
import { reducers as environmentReducers } from '../dux/environment-dux';
import { reducers as eoyReportReducers } from '../dux/eoy-report-dux';
import { reducers as mapReducers } from '../dux/map-dux';
import { reducers as plantingProductsReducers } from '../dux/planting-products-dux';
import { reducers as starterFertilizerReducers } from '../dux/starter-fertilizer-dux';
import { reducers as soilPendingFieldsReducers } from '../dux/soil-pending-fields-dux';
import { reducers as translationReducers } from '../dux/translations-dux';
import { reducers as alertsReducers } from '../dux/alerts-dux';
import { reducers as soilSampleOrderReducers } from '../dux/soil-sample-order-dux';
import { reducers as soilSamplingReducers } from '../dux/soil-sampling-dux';
import { reducers as authReducers } from '../dux/auth-dux';
import { reducers as cornrxReducers } from '../dux/cornrx-dux';
import { reducers as soyrxReducers } from '../dux/soyrx-dux';
import { reducers as yieldReducers } from '../dux/yield-dux';
import { reducers as nrxReducers } from '../dux/nrx-dux';
import { reducers as nProtectantReducers } from '../dux/n-protectant-dux';
import { reducers as earlySeasonFungicideReducers } from '../dux/early-season-fungicide-dux';
import { reducers as additionalServicesReducers } from '../dux/additional-services-dux';
import { reducers as fieldAgrilyticsReducers } from '../dux/field-agrilytics-dux';
import { reducers as plantingReducers } from '../dux/planting-dux';
import { reducers as productPlacementVPIReducers } from '../dux/product-placement-vpi-dux';
import { reducers as deereReducers } from '../dux/deere-dux';

const rootReducer = combineReducers({
  productivity,
  ...soilSampleOrderReducers,
  ...soilSamplingReducers,
  ...growerReducers,
  ...fieldReducers,
  ...fbmReducers,
  ...starterFertilizerReducers,
  ...featureFlagReducers,
  ...permissionReducers,
  ...soilPendingFieldsReducers,
  ...environmentReducers,
  ...eoyReportReducers,
  ...mapReducers,
  ...plantingProductsReducers,
  ...translationReducers,
  ...alertsReducers,
  ...authReducers,
  ...cornrxReducers,
  ...soyrxReducers,
  ...yieldReducers,
  ...nrxReducers,
  ...nProtectantReducers,
  ...earlySeasonFungicideReducers,
  ...additionalServicesReducers,
  ...fieldAgrilyticsReducers,
  ...plantingReducers,
  ...productPlacementVPIReducers,
  ...deereReducers,
});

export default rootReducer;
